import {
  CButton,
  CCardHeader,
  CCol,
  CInput,
  CInputGroup,
  CLabel,
  CRow,
  CSelect,
  CSpinner,
} from "@coreui/react";
import React, { useEffect, useState } from "react";
import { apiCall } from "src/_apiConfig/apiCall";
import Auth from "src/auth";
import CommonList from "src/views/common/CommonList";
import ConfirmationPopup from "src/views/common/ConfirmationPopup";
import TableButtonAnchor from "src/views/common/Table/TableButtonAnchor";
import TableButtonClick from "src/views/common/Table/TableButtonClick";

const LotListViewLotDocument = (props) => {
  const { authenticated } = Auth();
  const [designation, setdesignation] = useState();
  const [selectedFile, setSelectedFile] = useState();
  const [fileEvent, setFileEvent] = useState(false);
  const [documentName, setdocumentName] = useState("");
  const [disabledApproveRej, setdisabledApproveRej] = useState(false);

  const [deletedocumentopen, setdeletedocumentopen] = useState(false);
  const [deletedocumentid, setdeletedocumentid] = useState(false);

  const [ButtonLoaderUploadDocument, SetButtonLodaerUploadDocument] =
    useState(false);
  const handleDeleteDocumentOpen = (id) => {
    setdeletedocumentopen(true);
    setdeletedocumentid(id);
  };

  const handleeDeleteDocumentClose = () => setdeletedocumentopen(false);

  const SubmitConfirmationPopUpResponse = (id) => {
    handleeDeleteDocumentClose();
    deletedocument(id);
  };

  useEffect(() => {
    if (props.viewListDetails?.lotId !== "") {
      if (authenticated.role === "CFO" && authenticated.isViewOnly) {
        setdisabledApproveRej(true);
      } else {
        setdisabledApproveRej(false);
      }
    }
  }, [props.viewListDetails, authenticated]);

  const AgreementUpload = async (id) => {
    let e = fileEvent;
    if (e !== false) {
      if (authenticated) {
        let isValidfile = false;
        props.viewListDocument.forEach((data) => {
          if (data.type === "agreementletters") {
            if (
              e.target.files[0] !== undefined &&
              e.target.files[0].name.toLowerCase() ===
                "signed_" + data.fileName.toLowerCase()
            ) {
              isValidfile = true;
            }
          }
        });
        if (!isValidfile) {
          alert("Invalid File.");
        } else if (designation === undefined || designation === "0") {
          alert("Please select designation.");
        } else if (e.target.files[0].type === "application/pdf") {
          e.preventDefault();
          // setSelectedFile(e.target.files[0]);
          const files = e.target.files;
          const formData = new FormData();
          const header = new Headers();
          header.append("Accept", "application/json");
          formData.append("file", files[0]);
          const response = await apiCall(
            `LotDetails/UploadAgreementByBidder/${id}/${e.target.files[0].name}/${designation}`,
            "POST",
            header,
            formData
          );
          await response.text();
          if (response.status === 200) {
            props.viewListDetails.agreementStatus = 1;
            alert("Uploaded Successfully!");
            setdesignation(0);
            setdocumentName("");
            setSelectedFile();
            setFileEvent(false);
            window.location.reload();
            //props.getLotDetails(true);
          } else {
            alert("Error to upload file!");
          }
        } else {
          alert("Please Upload Only pdf file!");
        }
      }
    } else {
      alert("Please Choose A File!");
    }
  };

  const CFOAgreementUpload = async (id, cfoid) => {
    let e = fileEvent;
    if (e !== false) {
      if (authenticated) {
        let isValidfile = false;
        props.viewListDocument.forEach((data) => {
          if (data.type === "agreementletters") {
            if (
              e.target.files[0] !== undefined &&
              e.target.files[0].name.toLowerCase() ===
                "signed_signed_" + data.fileName.toLowerCase()
            ) {
              isValidfile = true;
            }
          }
        });
        if (!isValidfile) {
          alert("Invalid File.");
        } else if (e.target.files[0].type === "application/pdf") {
          SetButtonLodaerUploadDocument(true);
          e.preventDefault();
          setSelectedFile(e.target.files[0]);
          const files = e.target.files;
          const formData = new FormData();
          const header = new Headers();
          header.append("Accept", "application/json");
          formData.append("file", files[0]);
          const response = await apiCall(
            `LotDetails/UploadAgreementByCFO/${id}/${cfoid}`,
            "POST",
            header,
            formData
          );
          await response.text();
          if (response.status === 200) {
            props.viewListDetails.agreementStatus = 2;
            SetButtonLodaerUploadDocument(false);
            alert("Uploaded Successfully!");
            setSelectedFile();
            setFileEvent(false);
            props.getLotDetails(true);
          } else {
            alert("Error to upload file!");
          }
        } else {
          alert("Please Upload Only pdf file!");
        }
      }
    } else {
      alert("Please Choose A File!");
    }
  };

  const deletedocument = async (id) => {
    const header = new Headers();
    // header.append("", "");

    const response = await apiCall(
      `LotDetails/Deletedocument?id=${id}`,
      "PUT",
      header,
      null
    );
    await response.json();
    if (response.status === 200) {
      //window.location.reload();
      props.getLotDetails(true);
    }
  };

  const fields = [
    {
      key: "createdDate",
      label: <div>Created Date</div>,
    },
    {
      key: "fileName",
      label: <div>File Name</div>,
    },
    {
      key: "viewLotDocument",
      label: "View Lot Agreement",
      _style: { width: "20%" },
      sorter: false,
      filter: false,
    },
    {
      key: "deleteLotDocument",
      label: "Delete Lot Agreement",
      _style: { width: "10%" },
      sorter: false,
      filter: false,
    },
  ];
  const fieldsNodelete = [
    {
      key: "createdDate",
      label: <div>Created Date</div>,
    },
    {
      key: "fileName",
      label: <div>File Name</div>,
    },
    {
      key: "viewLotDocument",
      label: "View Lot Agreement",
      _style: { width: "20%" },
      sorter: false,
      filter: false,
    },
  ];
  let scopedSlotsList = {
    viewLotDocument: (item, index) => {
      return (
        <TableButtonAnchor
          fileName={item.fileName}
          path={item.documentpath}
          buttonName={"View"}
        />
      );
    },
    deleteLotDocument: (item, index) => {
      // {showbtn(props.isAllowToCCFDeleteTheBidderAgreement,item.fileName.toLowerCase())}

      return (
        <TableButtonClick
          buttonName={"Delete Lot Document"}
          color={"success"}
          isNormallBtn={false}
          isDisplayAllow={item.fileName.toLowerCase().includes("signed_")}
          onClick={() => handleDeleteDocumentOpen(item.id)}
        />
      );
    },
  };
  return (
    <>
      {authenticated.role === "Bidder" &&
        props.viewListDetails.isLotLeftHOApproval !== true &&
        props.viewListDetails.isSanctionAccepted === 1 &&
        (props.viewListDetails.isAgreementAccepted === 1 ||
          props.viewListDetails.tenderType === 2 ||
          props.viewListDetails.tenderType === 3 ||
          props.viewListDetails.agreementStatus === 0 ||
          props.EmdPaid.isEMDPaid === true) && (
          <>
            {/* <CCardHeader className="mb-3"> */}
            <CRow className="pt-3">
              <CCol xl={12}>
                <h3 className="titlehr">Upload Agreement</h3>
              </CCol>
            </CRow>

            <CRow className="mb-3">
              <CCol xl={4}>
                {/* //col-form-label */}
                <CLabel htmlFor="formFile" className="">
                  Upload Agreement
                </CLabel>
                {/* <CInputGroup className="mb-3"> */}
                <div className="custom-file">
                  <input
                    // disabled={
                    //   viewListDetails.isDisableUploadDocumentForBidder
                    // }
                    name="file"
                    id="inputGroupFile01"
                    type="file"
                    accept=".pdf"
                    className="custom-file-input"
                    onChange={(e) => {
                      setFileEvent(e);
                      setSelectedFile(e.target.files[0]);
                    }}
                  />
                  <label
                    className="custom-file-label "
                    htmlFor="inputGroupFile01"
                  >
                    {selectedFile ? selectedFile.name : <>Choose file</>}
                  </label>
                </div>
                {/* </CInputGroup> */}
              </CCol>

              <CCol xl={4}>
                <CLabel>Designation</CLabel>
                <CSelect
                  // disabled={
                  //   viewListDetails.isDisableUploadDocumentForBidder
                  // }
                  aria-label="Default select example"
                  onChange={(e) => {
                    setdesignation(e.target.value);
                  }}
                >
                  <option value="0">Select Designation</option>
                  <option value="1">Individual</option>
                  <option value="2">Proprietor</option>
                  <option value="3">Partner</option>
                  <option value="4">Director</option>
                  <option value="5">HUF Karta/Member</option>
                  <option value="6">Trustee</option>
                  <option value="7">Other Authorized Signatory</option>
                </CSelect>
              </CCol>

              <CCol xl={4}>
                <CLabel>Document Name</CLabel>
                <CInputGroup className="mb-3">
                  <CInput
                    type="text"
                    value={documentName}
                    name="documentName"
                    onChange={(e) => setdocumentName(e.target.value)}
                  />

                  <CButton
                    className="ml-3"
                    color="success"
                    onClick={() => AgreementUpload(props.viewListDetails.lotId)}
                  >
                    Upload Agreement
                  </CButton>
                </CInputGroup>
              </CCol>
            </CRow>
            {/* </CCardHeader> */}
          </>
        )}
{/* {authenticated.role} - {props.EmdPaid.isEMDPaid? "true": "false"} - {props.viewListDetails.isBidderSignedAgreement ? "true" : "false"} - 
{props.viewListDetails.isCCFSignedAgreement ? "true" : "false"} */}
      {/* || authenticated.role === "DFO" - Deep Gandhi @ 08-07-2024 After Discuss With Nikita ma'am*/}
      {authenticated.role === "CFO" &&
        props.viewListDetails.isLotLeftHOApproval !== true &&
        (((props.viewListDetails.isAgreementAccepted === 1 ||
          props.viewListDetails.tenderType === 2 ||
          props.viewListDetails.tenderType === 3) &&
          props.viewListDetails.agreementStatus === 1) ||
          props.EmdPaid.isEMDPaid === true) &&
        props.viewListDetails.isBidderSignedAgreement === true &&
        props.viewListDetails.isCCFSignedAgreement === false && (
          <>
            <CCardHeader className="mb-3">
              <h3 className="titlehr">Upload Agreement</h3>
              {/* <hr /> */}

              <CRow className="mb-3">
                <CCol xl={2}>
                  <CLabel
                    htmlFor="formFile"
                    className="col-sm-12 col-form-label"
                  >
                    Upload Agreement
                  </CLabel>
                </CCol>
                <CCol xl={4}>
                  <CInputGroup className="mb-3">
                    <div className="custom-file">
                      <input
                        name="file"
                        id="inputGroupFile01"
                        type="file"
                        accept=".pdf"
                        className="custom-file-input"
                        onChange={(e) => {
                          setFileEvent(e);
                          setSelectedFile(e.target.files[0]);
                        }}
                      />
                      <label
                        className="custom-file-label"
                        htmlFor="inputGroupFile01"
                      >
                        {selectedFile ? selectedFile.name : <>Choose file</>}
                      </label>
                    </div>
                    <div>
                      <CButton
                        className="ml-3"
                        color="success"
                        disabled={
                          disabledApproveRej || ButtonLoaderUploadDocument
                        }
                        onClick={() => {
                          !ButtonLoaderUploadDocument &&
                            CFOAgreementUpload(
                              props.viewListDetails.lotId,
                              authenticated.userId
                            );
                        }}
                        //disabled={ButtonLoader}
                      >
                        {ButtonLoaderUploadDocument && (
                          <>
                            <CSpinner as="span" size="sm" aria-hidden="true" />
                            &nbsp;
                          </>
                        )}
                        Upload Agreement
                      </CButton>
                      {/* <CButton
                        className="ml-3"
                        disabled={disabledApproveRej}
                        color="success"
                        onClick={() =>
                          CFOAgreementUpload(
                            props.viewListDetails.lotId,
                            authenticated.userId
                          )
                        }
                      >
                        Upload Document
                      </CButton> */}
                    </div>
                  </CInputGroup>
                </CCol>
              </CRow>
            </CCardHeader>
          </>
        )}

      <CRow className={"viewTable "}>
        <CCol xl={12}>
          <CommonList
            items={props.viewListDocument}
            fields={
              props.viewListDetails?.isAllowToCCFDeleteTheBidderAgreement ===
              true
                ? fields
                : fieldsNodelete
            }
            listName="Lot Agreement" // Lot Documents
            loading={false}
            path="/lotlistview/"
            tabBtn="View"
            id="lotId"
            disabledprev={true}
            disablednext={true}
            isAllowToCCFDeleteTheBidderAgreement={
              props.viewListDetails?.isAllowToCCFDeleteTheBidderAgreement
            }
            deletedocument={deletedocument}
            tenderId={props.viewTenderDetails?.tenderId}
            scopedSlots={scopedSlotsList}
            displayPaggingButton={false}
          />
        </CCol>
      </CRow>
      <ConfirmationPopup
        showModal={deletedocumentopen}
        hideModal={handleeDeleteDocumentClose}
        confirmModal={SubmitConfirmationPopUpResponse}
        id={deletedocumentid}
        index={"-1"}
        ModalBody={"Are you sure you want to Delete Document?"}
        // ModalTitle={CPopUpTitle}
        confirmButtonCss="btn btn-danger"
        ButtonLoader={false}
      />
    </>
  );
};

export default LotListViewLotDocument;
